import React from 'react';
import { useIntl } from 'react-intl';
import MessageBox, { MESSAGE_BOX_VARIANT_WARNING } from '@components/2-molecules/MessageBox';
import { interruptedNoticeCopy } from './InterruptedNotice.constants';

interface InterruptedNoticeProps {
  /** `termination_reason` the turn was recorded with; picks the copy and the action. */
  reason?: string;
  /**
   * Retries the turn — with `prompt` when the action sends a follow-up instead of
   * the original message. Omitted, the notice renders without an action.
   */
  onRetry?: (prompt?: string) => void;
}

const InterruptedNotice: React.FC<InterruptedNoticeProps> = ({ reason, onRetry }) => {
  const intl = useIntl();
  const copy = interruptedNoticeCopy(reason);
  const followUp = copy.followUpPrompt ? intl.formatMessage(copy.followUpPrompt) : undefined;
  return (
    <MessageBox
      variant={MESSAGE_BOX_VARIANT_WARNING}
      endingButtonTitle={onRetry ? intl.formatMessage(copy.action) : undefined}
      onEndingButtonClick={onRetry ? () => onRetry(followUp) : undefined}
      dataTestId="interrupted-notice"
    >
      <span>{intl.formatMessage(copy.message)}</span>
    </MessageBox>
  );
};

export default InterruptedNotice;
